// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class GoogleMapDetail extends WebComponent {
    constructor(props) {
        super(props);
        this.initMap = this.initMap.bind(this);
    }

    didMount() {
        const {
            lat,
            lng,
            iconType,
        } = this.props;

        const mapElement = this.element;
        const markers =  [
            // default marker, empty
            {},
            {
                icon						:	{
                    url: '/img/u/markers.png?v01',
                    size: new google.maps.Size(42,56),
                    origin: new google.maps.Point(6,213),
                    anchor: new google.maps.Point(21,56)
                },
                shape						:	{
                    coords					:		[26,0,36,5,20,42,21,56,0,20,6,5],
                    type					:		'poly'
                }
            },
            {
                icon						:	{
                    url: '/img/u/markers.png?v01',
                    size: new google.maps.Size(53,71),
                    origin: new google.maps.Point(0,71),
                    anchor: new google.maps.Point(26,71)
                },
                shape						:	{
                    coords					:		[26,0,44,5,53,25,26,71,0,25,7,5],
                    type					:		'poly'
                }
            }
        ]
        this.initMap(mapElement,parseFloat(lat),parseFloat(lng),markers,iconType);
    }

    initMap(mapElement, coordLat, coordLng, markers, iconType) {
        const location = {lat: coordLat, lng: coordLng};
        // The map, centered
        const map = new google.maps.Map(
            mapElement, {
                zoom: 13,
                center: location,
                minZoom: 3,
                mapTypeControl:    false,
                scaleControl:      false,
                panControl:        true,
                streetViewControl: false,
                zoomControl:       true,
                scrollwheel:       false,
                styles: [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.country",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#cbcbcb"
                            },
                            {
                                "weight": 2
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dde6e8"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ]
            });
        // The marker, positioned
        const marker = new google.maps.Marker({position: location, icon: markers[parseInt(iconType)].icon, map: map});
    }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoogleMapDetail.js